import { useAreLeadershipManagementFlightsEnabled } from '../leaderSettings';

import { useCanUserAccessLeadershipCorner } from './useCanUserAccessLeadershipCorner';

type UseCanUserAccessLeaderDirectory = () => boolean;
export const useCanUserAccessLeaderDirectory: UseCanUserAccessLeaderDirectory = () => {
  const areLeadershipManagementFlightsEnabled = useAreLeadershipManagementFlightsEnabled();
  const canUserAccessLeadershipCorner = useCanUserAccessLeadershipCorner();

  return areLeadershipManagementFlightsEnabled && canUserAccessLeadershipCorner;
};
